// extracted by mini-css-extract-plugin
module.exports = {"tablePlayButton":"TablePlayButton_tablePlayButton__9FGvu","icon":"TablePlayButton_icon__W9vFp","hideDefault":"TablePlayButton_hideDefault__3-wIG"};